/* La Cueva de Nick - auto-ajuste de variantes.
   Cuando el cliente elige un valor (ej. "Reverse Holo") cuya combinacion con
   los otros selectores no existe, ajustamos los otros selectores a la primera
   variante disponible que contiene el valor elegido. Corre en fase de captura,
   antes de que Dawn (VariantSelects) recoja la seleccion, para que Dawn reciba
   una combinacion valida. No hace nada si la combinacion ya es valida. */
(function () {
  var fixing = false;
  function variantsOf(root) {
    var el = root.querySelector('[data-clcv-variants]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function fieldsetsOf(root) {
    return Array.prototype.slice.call(root.querySelectorAll('fieldset.product-form__input'));
  }
  function esc(v) {
    if (window.CSS && CSS.escape) return CSS.escape(v);
    return String(v).replace(/["\\]/g, '\\$&');
  }
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (fixing || !input || !input.matches || !input.matches('input[type="radio"]')) return;
    var root = input.closest('variant-selects');
    if (!root) return;
    var variants = variantsOf(root);
    var fs = fieldsetsOf(root);
    if (!variants || fs.length < 2) return;
    var values = fs.map(function (f) {
      var c = f.querySelector('input[type="radio"]:checked');
      return c ? c.value : null;
    });
    var exact = variants.find(function (v) {
      return v.available && v.options.length === values.length &&
             v.options.every(function (o, i) { return o === values[i]; });
    });
    if (exact) return;
    var idx = fs.indexOf(input.closest('fieldset'));
    if (idx < 0) return;
    var chosen = input.value;
    var cand = variants.find(function (v) { return v.available && v.options[idx] === chosen; }) ||
               variants.find(function (v) { return v.options[idx] === chosen; });
    if (!cand) return;
    fixing = true;
    fs.forEach(function (f, i) {
      if (i === idx) return;
      var want = cand.options[i];
      var r = f.querySelector('input[type="radio"][value="' + esc(want) + '"]');
      if (r && !r.checked) { r.checked = true; }
    });
    fixing = false;
  }, true);
})();
